<template>
  <div id="printResults" class="background print-results-table">
    <div class="overlay container">
      <div type="button" class="btn-exit" @click="$router.push({ name: 'settings' })">
      <img src="@/assets/icons/menu/windows_control/Close_1.svg" alt />
      <!-- {{ $t('pretest.exit') }} -->
    </div>
      <div class="row">
        <div class="col-4 mainResults">
          <div class="col-12 mb-3 student-header">
            {{ test.studentName }} -
            {{ test.gradeName }}
            <span v-if="evaluation.isFullEvaluation === 0">- (All subjects)</span>
            - {{ dateNow }}
          </div>
          <div class="results-container">
            <h1>{{ $t('fullResult.result') }}</h1>
            <div class="results">
              <ul>
                <li v-for="(subject, index) in evaluation" :key="index">
                  <span class="results-subject">{{ index | deleteNumbers }}:</span>
                  <span class="results-scores">
                    <span>{{ subject | evaluateSubjectByPercentage }}%</span>
                    <span>-</span>
                    <span>{{ subject | evaluateSubjectByPercentage | evaluateByLetters }}</span>
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div v-if="evaluation.isFullEvaluation === 0" class="rec-container">
            <h4>{{ $t('fullResult.recommendations') }}</h4>
            <p>{{ $t('fullResult.itIsSuggested') }}</p>
            <h3>
              <template v-if="evaluation.isFullEvaluation === 0">
                <span v-for="(subject, index) in evaluation" :key="index">{{ index | deleteNumbers }}</span>
              </template>
            </h3>
          </div>
        </div>
        <div class="col-8 mainDashboard">
          <div class="screen">
            <div class="graph">
              <h1 class="graph-title">{{ $t('fullResult.previousStatistics') }}</h1>
              <ul class="section_score_wrapper" :class="{ active: scoresActive }">
                <li
                  v-for="(subject, key, index) in evaluation"
                  :key="index"
                  class="section_score"
                  :class="key | deleteNumbers"
                >
                  <div
                    :ref="index"
                    class="section_score_bar"
                    :class="{ active: barClassActive }"
                    :style="{ height: getScore(subject) + '%' }"
                  >
                    <p class="section_score_num" :style="numsStyleActive ? 'opacity: 1;' : ''">
                      {{ subject | evaluateSubjectByPercentage | parseInt }} <span style="font-size: 9px;">%</span>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="subjects">
            <div v-for="(subject, key, index) in evaluation" :key="index" class="subject" :class="key | deleteNumbers">
              <span></span>
              {{ key | deleteNumbers }}
            </div>
          </div>
          <div class="wrap__button">
            <div class="print-button" type="button" @click="printPage">
              {{ $t('messages.printPage') }}
            </div>
            <div class="previus-button" @click="togglePreviousResults">
              {{ $t('fullResult.previousResults') }}
              <!-- <img src="@/assets/img/arrowNextBook-right.png" alt /> -->
            </div>
            <img src="@/assets/TPM_yourpath.svg" alt class="tpm-logo" />
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="$t('previousResults.scoreComparison')" :visible.sync="showPrevResults" top="1vh" width="95%">
      <div class="results-screen">
        <div class="previous-results">
          <div class="results-title block w-100">
            <label class="text-capitalize">{{ test.studentName }} - {{ test.gradeName }} - {{ dateNow }}</label>
          </div>
          <div class="results block w-100">
            <ul>
              <li v-for="(subject, index) in evaluation" :key="index">
                <div>
                  <span class="results-subject">{{ index | deleteNumbers }}:</span>
                  <span class="results-scores">
                    <span>{{ subject | evaluateSubjectByPercentage }}%</span> -
                    <span>{{ subject | evaluateSubjectByPercentage | evaluateByLetters }}</span>
                  </span>
                </div>
                <div class="subject" :class="index | deleteNumbers">
                  <span></span>
                  {{ index | deleteNumbers }}
                </div>
              </li>
            </ul>
          </div>
          <div class="screen">
            <div class="graphs-results">
              <div class="graph">
                <ul class="section_score_wrapper" :class="{ active: scoresActive }">
                  <li
                    v-for="(subject, key, index) in evaluation"
                    :key="index"
                    class="section_score"
                    :class="key | deleteNumbers"
                  >
                    <div
                      :ref="index"
                      class="section_score_bar"
                      :class="{ active: barClassActive }"
                      :style="{ height: getScore(subject) + '%' }"
                    >
                      <p class="section_score_num" :style="numsStyleActive ? 'opacity: 1;' : ''">
                        {{ subject | evaluateSubjectByPercentage | parseInt }}
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div id="prev-results" class="previous-results">
          <Carousel
            class="pastel-graphic"
            :navigation-enabled="true"
            navigation-prev-label
            navigation-next-label
            :per-page="1"
            pagination-active-color="#000"
            pagination-color="#999"
          >
            <Slide v-if="evaluations.length" class="not-history">
              <div>
                <h1>{{ $t('previousResults.noHistory') }}</h1>
              </div>
            </Slide>
            <Slide v-for="(_evaluation, index) in evaluations" :key="index">
              <div class="results-title">
                <label class="text-capitalize">{{ test.studentName }} - {{ _evaluation[0].grade_name }}</label>
              </div>
              <div class="results results-slider">
                <ul>
                  <li v-for="(item, subjectIndex) in _evaluation" :key="subjectIndex">
                    <div>
                      <span class="results-subject">{{ item.subject_name }}:</span>
                      <span class="results-scores">
                        <span>{{ item.average }}%</span> -
                        <span>{{ item.average | evaluateByLetters }}</span>
                      </span>
                    </div>
                    <div :class="('subject ' + item.subject_name) | deleteNumbers">
                      <span></span>
                      {{ item.subject_name | deleteNumbers }}
                    </div>
                  </li>
                </ul>
              </div>
              <div class="screen">
                <div class="graphs-results">
                  <div class="graph">
                    <ul class="section_score_wrapper ul-slider" :class="{ active: scoresActive }">
                      <li
                        v-for="(_item, key) in _evaluation"
                        :key="key"
                        class="section_score"
                        :class="_item.subject_name | deleteNumbers"
                      >
                        <div
                          :ref="key"
                          class="section_score_bar"
                          :class="{ active: barClassActive }"
                          :style="{ height: _item.average + '%' }"
                        >
                          <p class="section_score_num" :style="numsStyleActive ? 'opacity: 1;' : ''">
                            {{ _item.average }}
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </Slide>
          </Carousel>
        </div>
      </div>
    </el-dialog>
  
  </div>
</template>
<script>
import { Carousel, Slide } from 'vue-carousel';
import _ from 'lodash';
import moment from 'moment';

export default {
  name: 'Results',
  components: {
    Carousel,
    Slide,
  },
  props: {
    test: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dateNow: moment().format('L'),
      evaluation: {},
      evaluations: [],
      evaluationsFromDB: [],
      /** Graph */
      scoresActive: false,
      barClassActive: false,
      numsStyleActive: false,
      showPrevResults: false,
    };
  },
  created() {
    this.evaluation = _.groupBy(this.test.questions, 'subject_name');
    this.fetchEvaluations();
  },
  mounted() {
    /** Se activan la clase 'active' en la grafica */
    setTimeout(() => {
      this.scoresActive = true;
      this.barClassActive = true;
    }, 500);
    setTimeout(() => {
      this.numsStyleActive = true;
    }, 1000);
  },
  methods: {
    printPage() {
      print();
      // this.$htmlToPaper('printResults');
    },
    fetchEvaluations() {
      this.$httpMain
        .post(`get_all_evaluations_per_student`, {
          student_id: parseInt(this.test.userId),
        })
        .then(res => {
          this.evaluations = _.groupBy(res.data.subjects, 'key');
          // try {
          //   let evaluations = _.groupBy(res.data.subjects, 'key');
          //   Object.entries(evaluations).forEach((entry, index) => {
          //     const [key, value] = entry;
          //     if (index > 0) {
          //       this.evaluation.push({});
          //     }
          //     console.log(key, value);
          //   });
          // } catch (err) {
          //   console.log(err);
          // }
        });
    },
    togglePreviousResults() {
      this.showPrevResults = !this.showPrevResults;
    },
    /** Muestra al componente FullResults */
    goToFullResults() {
      // this.$router.push('/tutor/full-results')
      this.showDetails = true;
      this.$store.commit('SHOW_OR_HIDDEN_FULLRESULTS_COMPONENT_EVALUATION', true);
    },
    getPercentage(array) {
      var correctAnswers = 0;
      array.forEach(element => {
        if (element.result === true) {
          correctAnswers++;
        }
      });
      /** Calcula el porcentaje de repuestas correctas */
      var percentage = (correctAnswers * 100) / _.size(array);
      // this.$refs[index][0].style.height = percentage + '%'
      /** Verifica que el porcentaje sea mayor a una calificación aprobatoria */
      if (percentage >= 59) {
        return false;
      } else {
        return true;
      }
    },
    getScore(subject) {
      var correctAnswers = 0;
      subject.forEach(question => {
        if (question.answered_correctly) {
          correctAnswers++;
        }
      });
      /** Calcula el porcentaje de repuestas correctas */
      var value = (correctAnswers * 100) / _.size(subject);
      return value % 1 === 0 ? value : value.toFixed(2);
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin my-button{
  border: 1px solid #4caf50;
    color: #4caf50;
    min-width: 80px;
      &:hover{
        border: unset;
        background-color: rgba($color: #4caf50, $alpha: 0.2);
      }
}
.wrap__button{
  display: flex;
  justify-content: space-around;
  align-items: center;
  div{
    width: 250px;
    border: 1px solid rebeccapurple;
    font-family: "FuturaBold", Helvetica, Arial;
    cursor: pointer;
    padding: 1rem;
    border-radius: 30px;
    box-shadow: 5px 8px 7px -9px rgba(0,0,0,0.75);
    text-align: center;
  }
  .print-button{
    @include my-button();
  }
  .previus-button{
    @include my-button();
  }
}
.background {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(100vh - 35px);
  min-height: min-content;
  background-color: rgba(0, 0, 0, 0.5);
}
.overlay {
  position: relative;
  min-width: 1100px;
  min-height: 500px;
  padding: 40px;
  margin: 15px 0;
  font-family: 'comfortaaregular';
  background-color: #fff;
  border-radius: 30px;
}
.results-container {
  position: relative;
  background-color: #58cde8;
  border-radius: 30px;
  h1 {
    position: absolute;
    top: 24px;
    width: calc(100% + 20px);
    margin: 0;
    padding: 10px 20px 5px;
    color: #fff;
    font-family: 'comfortaabold';
    font-size: 24px;
    background-color: #ffcd16;
    text-transform: uppercase;
    transform: translateX(-10px);
  }
  h1:after,
  h1:before {
    position: absolute;
    content: '';
  }
  h1:before {
    left: 0;
    bottom: -10px;
    border-left: 10px solid transparent;
    border-top: 10px solid #ad8812;
  }
  h1:after {
    right: 0;
    bottom: -10px;
    border-right: 10px solid transparent;
    border-top: 10px solid #ad8812;
  }
}
.results {
  color: #fff;
  padding: 90px 20px 20px;
  li {
    display: flex;
    justify-content: space-between;
  }
  li + li {
    margin-top: 10px;
  }
}
.results-scores {
  display: flex;
  //  justify-content: space-between;
  min-width: 120px;
  span:nth-child(1) {
    min-width: 60px;
    display: inline-block;
  }
  span:nth-child(2) {
    display: inline-block;
    min-width: 40px;
  }
}
.rec-container {
  padding: 15px;
  margin: 30px 20px 0;
  color: #fff;
  text-align: center;
  background-color: #add42d;
  border-radius: 20px;
  h4 {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  p {
    font-size: 18px;
    line-height: 22px;
    margin-bottom: 10px;
  }
  h3 {
    font-size: 20px;
    font-weight: bold;
    color: #9a0bff;
    span:after {
      content: ', ';
    }
    span:last-child:after {
      content: '.';
    }
  }
}
.student-header {
  text-transform: capitalize;
  margin-top: 3px;
}
.screen {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
  height: 340px;
  background-color: #c1ced8;
  .graph {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: #c3cfd9;
    border-radius: 5px;
  }
}
/* Graphs */
.section_score {
  height: 170px;
  display: flex;
  flex-direction: column-reverse;
  float: left;
  position: relative;
  text-align: center;
  margin-right: 20px;
  perspective: 1000px;
  transition: all 0.3s ease-in-out;
}
.graph-title {
  font-size: 25px;
  color: #ffffff;
  font-family: 'comfortaabold';
  margin-bottom: 25px;
}
.section_score .section_label {
  position: absolute;
  bottom: -55px;
  width: 100%;
  font-size: 14px;
  display: flex;
  font-family: 'comfortaabold';
  align-items: center;
  justify-content: center;
  height: 40px;
  line-height: 1;
}
.section_score .section_score_num {
  background-color: #fff;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  padding: 4px;
  display: inline-block;
  border: 3px solid #a9a9a9;
  position: relative;
  top: -15px;
  opacity: 0;
  font-size: 12px;
  font-weight: bold;
  transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}
.section_score:last-child {
  margin-right: 0;
}
.section_score.Pk,
.section_score.Pk {
  background-color: rgba(orange, 0.25);
  .section_score_bar {
    background-color: orange;
  }
}
.section_score.Tk,
.section_score.Tk {
  background-color: rgba(#20c997, 0.25);
  .section_score_bar {
    background-color: #20c997;
  }
}
.section_score.Math,
.section_score.Matemáticas {
  background-color: rgba(#2693fc, 0.25);
  .section_score_bar {
    background-color: #2693fc;
  }
}
.section_score.Grammar,
.section_score.Gramática {
  background-color: rgba(#f4cf14, 0.25);
  .section_score_bar {
    background-color: #f4cf14;
  }
}
.section_score.Reading,
.section_score.Lectura.y.comprensión {
  background-color: rgba(#f50c0d, 0.25);
  .section_score_bar {
    background-color: #f50c0d;
  }
}
.section_score.Science,
.section_score.Ciencias {
  background-color: rgba(#b51da3, 0.25);
  .section_score_bar {
    background-color: #b51da3;
  }
}
.section_score.Social.Studies,
.section_score.Ciencias.sociales {
  background-color: rgba(#2aaf0a, 0.25);
  .section_score_bar {
    background-color: #2aaf0a;
  }
}
.section_score.Vocabulary,
.section_score.Vocabulario {
  background-color: rgba(#ff790b, 0.25);
  .section_score_bar {
    background-color: #ff790b;
  }
}
.section_score.American.History {
  background-color: rgba(#0052b7, 0.25);
  .section_score_bar {
    background-color: #0052b7;
  }
}
.section_score.Biology {
  background-color: rgba(#9ef835, 0.25);
  .section_score_bar {
    background-color: #9ef835;
  }
}
.section_score.Chemistry {
  background-color: rgba(#880b8b, 0.25);
  .section_score_bar {
    background-color: #880b8b;
  }
}
.section_score.Physics {
  background-color: rgba(#36c17d, 0.25);
  .section_score_bar {
    background-color: #36c17d;
  }
}
.section_score.World.Studies {
  background-color: rgba(#932f1d, 0.25);
  .section_score_bar {
    background-color: #932f1d;
  }
}
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.section_score_bar {
  order: 0;
  width: 60px;
  background: white;
  transform: scaleY(0) translate3d(0, 0, 0);
  transform-origin: center bottom;
  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);
  transition-delay: 0.1s;
}
.section_score_bar.active {
  transform: none;
}
.subjects {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: 100px;
  margin-top: 20px;
  .subject {
    display: flex;
    flex-grow: 1;
    height: 33%;
    font-family: 'comfortaabold';
    span {
      display: inline-block;
      width: 45px;
      height: 15px;
      border-radius: 3px;
      margin-right: 10px;
    }
  }
  .subject.Pk span {
    background-color: orange;
  }
  .subject.Tk span {
    background-color: #20c997;
  }
  .subject.Math span {
    background-color: #2693fc;
  }
  .subject.Grammar span {
    background-color: #f4cf14;
  }
  .subject.Reading span {
    background-color: #f50c0d;
  }
  .subject.Science span {
    background-color: #b51da3;
  }
  .subject.Social.Studies span {
    background-color: #2aaf0a;
  }
  .subject.Vocabulary span {
    background-color: #ff790b;
  }
  .subject.American.History span {
    background-color: #0052b7;
  }
  .subject.Biology span {
    background-color: #9ef835;
  }
  .subject.Chemistry span {
    background-color: #880b8b;
  }
  .subject.Physics span {
    background-color: #36c17d;
  }
  .subject.World.Studies span {
    background-color: #932f1d;
  }
}
.btn:focus {
  outline: none;
  box-shadow: none;
}

.print-page {
  height: 52px;
  width: auto;
  padding-top: 10px;
  background-color: #607d8b;
  user-select: none;
  border: none;
  border-radius: 5px;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  cursor: pointer;
  color: #fff;
  font-size: 22px;
  font-family: 'comfortaabold';
  margin-right: 20px;
  &:focus {
    outline: none;
  }
}
.modal-header {
  border: none;
  text-align: center;
  h1 {
    margin: 0;
    color: #000;
    font-size: 26px;
    margin: auto;
  }
  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    opacity: 1;
    img {
      width: 30px;
    }
    &:focus {
      outline: none;
    }
  }
}

.results-screen {
  display: flex;
  flex-wrap: wrap;
}

.previous-results {
  width: 50%;
  // @include forTablet {
  //   width: 50%;
  // }
  padding: 10px 30px;
  flex-grow: 1;
  // Removing flex-basis fixes issue with Previous results in Score comparison. (In Firefox browser)
  // flex-basis: 0;
  &:nth-child(1) {
    border-right: 3px solid #58cde8;
  }
  .results-title {
    height: 32px;
    label {
      font-weight: 600;
      line-height: 20px;
    }
  }
  .results {
    color: #000;
    padding: 0;
    ul {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height: 180px;
    }
    li {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      font-size: 16px;
      > div:nth-child(1) {
        display: flex;
        flex-grow: 2;
        flex-basis: 0;
        justify-content: space-between;
        padding-right: 40px;
        font-family: 'comfortaabold';
        .results-scores {
          display: flex;
          align-items: center;
          justify-content: space-between;
          min-width: 80px;
        }
      }
      > div:nth-child(2) {
        flex-grow: 1;
        flex-basis: 0;
        min-width: 200px;
      }
    }
    .subject {
      display: flex;
      flex-grow: 1;
      height: 33%;
      font-family: 'comfortaaregular';
      span {
        display: inline-block;
        width: 45px;
        height: 15px;
        border-radius: 3px;
        margin-right: 10px;
      }
    }
    li .subject.Pk span {
      background-color: orange;
    }
    li .subject.Tk span {
      background-color: #20c997;
    }
    li .subject.Math span {
      background-color: #2693fc;
    }
    li .subject.Grammar span {
      background-color: #f4cf14;
    }
    li .subject.Reading span {
      background-color: #f50c0d;
    }
    li .subject.Science span {
      background-color: #b51da3;
    }
    li .subject.Social.Studies span {
      background-color: #2aaf0a;
    }
    li .subject.Vocabulary span {
      background-color: #ff790b;
    }
    li .subject.American.History span {
      background-color: #0052b7;
    }
    li .subject.Biology span {
      background-color: #9ef835;
    }
    li .subject.Chemistry span {
      background-color: #880b8b;
    }
    li .subject.Physics span {
      background-color: #36c17d;
    }
    li .subject.World.Studies span {
      background-color: #932f1d;
    }
  }
  .screen {
    height: 250px;
    margin: 10px 0 0;
    .section_score {
      margin-right: 10px;
      margin-bottom: 0;
      &:last-child {
        margin-right: 0;
      }
      .section_score_bar {
        width: 50px;
      }
    }
  }
}
.tpm-logo {
  //position: absolute;
  width: 100px;
  //bottom: -35px;
  //right: 15px;
}
.not-history {
  height: 475px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 575px) {
  .overlay {
    min-height: 900px;
    top: 120px;
  }
  .mainResults {
    left: 350px;
  }
  .mainDashboard {
    top: 300px;
  }
  .student-header {
    display: flex;
    justify-content: center;
  }
  .previous-results {
    width: 100%;
    //height: 770px;
    &:nth-child(1) {
      border-right: unset;
      border-bottom: 3px solid #58cde8;
    }
    .results {
      ul {
        height: unset;
        width: 100%;
        display: flex;
        margin-left: 20px;
      }
      li {
        font-size: 12px;
      }
    }
    .results-slider {
      ul {
        height: unset;
        width: 100%;
        display: block;
        margin-left: 0px;
        li {
          display: block;
        }
      }
    }
    .screen {
      margin: 30px 0 0;
      height: 200px;
      .section_score {
        //margin-bottom: 5px;
        .section_score_bar {
          width: 30px;
        }
      }
    }
    .graph {
      .ul-slider {
        // margin-bottom: 100px;
      }
    }
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .overlay {
    min-height: 1000px;
    top: 0px;
  }
  .mainResults {
    left: 350px;
    //top: 40px;
    top: 260px;
  }
  .mainDashboard {
    left: -100px;
    // top: 400px;
    top: 620px;
  }
  .student-header {
    margin-top: 77px;
  }
  .previous-results {
    width: 100%;
    &:nth-child(1) {
      border-right: unset;
      border-bottom: 3px solid #58cde8;
    }
  }
}
@media (min-width: 768px) and (max-width: 1100px) {
  .overlay {
    min-height: 1000px;
    top: 0px;
  }
  .student-header {
    margin-top: 77px; //hghg
  }
  .mainResults {
    left: 150px;
    top: 70px;
  }
  .mainDashboard {
    left: -200px;
    top: 430px;
  }
  .previous-results {
    width: 100%;
    &:nth-child(1) {
      border-right: unset;
      border-bottom: 3px solid #58cde8;
    }
  }
}
</style>
<style lang="scss">
#prev-results {
  .VueCarousel-pagination {
    .VueCarousel-dot {
      margin-top: 0 !important;
    }
  }
  .VueCarousel-navigation--disabled {
    color: #ff6d00;
  }
  .VueCarousel-navigation-button.VueCarousel-navigation-prev {
    display: block;
    background-image: url('~@/assets/img/navigation-left.png');
    background-repeat: no-repeat;
    height: 64px;
    width: 20px;
    left: -5px;
  }
  .VueCarousel-navigation-button.VueCarousel-navigation-next {
    display: block;
    background-image: url('~@/assets/img/navigation-right.png');
    background-repeat: no-repeat;
    height: 64px;
    width: 20px;
    right: -5px;
  }
  .not-evaluation {
    text-align: center;
  }
}

@media print {
  @page {
    margin: 2cm;
    page-break-before: avoid;
    page-break-after: avoid;
    page-break-inside: avoid;
    size: 960px;
    // .print-results-table {
    //   height: 1300px;
    // }
  }
  .navbar-tpm {
    display: none !important;
  }

  .print-results-table {
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    //height: 1000px;
    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
    .overlay {
      background-color: #fff !important;
      -webkit-print-color-adjust: exact;
    }
    .mainResults {
      -webkit-print-color-adjust: exact;
      .results-container {
        background-color: #58cde8 !important;
        -webkit-print-color-adjust: exact;
        h1 {
          color: #fff !important;
          background-color: #ffcd16 !important;
          -webkit-print-color-adjust: exact;
        }
      }
    }
    .results span {
      color: #fff !important;
      -webkit-print-color-adjust: exact;
    }
    .rec-container {
      background-color: #add42d !important;
      -webkit-print-color-adjust: exact;
      h4,
      p {
        color: #fff !important;
        -webkit-print-color-adjust: exact;
      }
      h3 span {
        color: #9a0bff !important;
        -webkit-print-color-adjust: exact;
        &:after {
          color: #9a0bff !important;
          -webkit-print-color-adjust: exact;
        }
      }
    }
    .mainDashboard {
      -webkit-print-color-adjust: exact;
      .screen {
        background-color: #c1ced8 !important;
        -webkit-print-color-adjust: exact;
        .graph {
          background-color: #c3cfd9 !important;
          -webkit-print-color-adjust: exact;
        }
      }
    }
    .graph-title {
      color: #ffffff !important;
      -webkit-print-color-adjust: exact;
    }
    .section_score .section_score_num {
      background-color: #fff !important;
      border: 3px solid #a9a9a9 !important;
      -webkit-print-color-adjust: exact;
    }
    .section_score,
    .section_score_bar {
      -webkit-print-color-adjust: exact;
    }
    .section_score.Pk {
      background-color: rgba(orange, 0.25) !important;
      .section_score_bar {
        background-color: orange !important;
      }
    }
    .section_score.Tk {
      background-color: rgba(#20c997, 0.25) !important;
      .section_score_bar {
        background-color: #20c997 !important;
      }
    }
    .section_score.Math {
      background-color: rgba(#2693fc, 0.25) !important;
      .section_score_bar {
        background-color: #2693fc !important;
      }
    }
    .section_score.Grammar {
      background-color: rgba(#f4cf14, 0.25) !important;
      .section_score_bar {
        background-color: #f4cf14 !important;
      }
    }
    .section_score.Reading {
      background-color: rgba(#f50c0d, 0.25) !important;
      .section_score_bar {
        background-color: #f50c0d !important;
      }
    }
    .section_score.Science {
      background-color: rgba(#b51da3, 0.25) !important;
      .section_score_bar {
        background-color: #b51da3 !important;
      }
    }
    .section_score.Social.Studies {
      background-color: rgba(#2aaf0a, 0.25) !important;
      .section_score_bar {
        background-color: #2aaf0a !important;
      }
    }
    .section_score.Vocabulary {
      background-color: rgba(#ff790b, 0.25) !important;
      .section_score_bar {
        background-color: #ff790b !important;
      }
    }
    .section_score.American.History {
      background-color: rgba(#0052b7, 0.25) !important;
      .section_score_bar {
        background-color: #0052b7 !important;
      }
    }
    .section_score.Biology {
      background-color: rgba(#9ef835, 0.25) !important;
      .section_score_bar {
        background-color: #9ef835 !important;
      }
    }
    .section_score.Chemistry {
      background-color: rgba(#880b8b, 0.25) !important;
      .section_score_bar {
        background-color: #880b8b !important;
      }
    }
    .section_score.Physics {
      background-color: rgba(#36c17d, 0.25) !important;
      .section_score_bar {
        background-color: #36c17d !important;
      }
    }
    .section_score.World.Studies {
      background-color: rgba(#932f1d, 0.25) !important;
      .section_score_bar {
        background-color: #932f1d !important;
      }
    }
    .section_score_bar {
      background: #fff !important;
    }
    .subjects {
      .subject span {
        -webkit-print-color-adjust: exact;
      }
      .subject.Math span {
        background-color: #2693fc !important;
      }
      .subject.Grammar span {
        background-color: #f4cf14 !important;
      }
      .subject.Reading span {
        background-color: #f50c0d !important;
      }
      .subject.Science span {
        background-color: #b51da3 !important;
      }
      .subject.Social.Studies span {
        background-color: #2aaf0a !important;
      }
      .subject.Vocabulary span {
        background-color: #ff790b !important;
      }
      .subject.American.History span {
        background-color: #0052b7 !important;
      }
      .subject.Biology span {
        background-color: #9ef835 !important;
      }
      .subject.Chemistry span {
        background-color: #880b8b !important;
      }
      .subject.Physics span {
        background-color: #36c17d !important;
      }
      .subject.World.Studies span {
        background-color: #932f1d !important;
      }
    }
    .button {
      display: none !important;
    }
    .print-page {
      display: none !important;
    }
  }

  .result-text-one-print {
    .score {
      background-color: #fff !important;
      -webkit-print-color-adjust: exact;
    }
    .score-percent {
      .icon {
        background-color: #ff8500 !important;
        -webkit-print-color-adjust: exact;
      }
      .percent {
        border: 4px solid #ff8500 !important;
        -webkit-print-color-adjust: exact;
        span {
          color: #fff !important;
          -webkit-print-color-adjust: exact;
        }
        .percent-background {
          background: linear-gradient(to right, #c70000 50%, #4c845d 70%) !important;
          -webkit-print-color-adjust: exact;
        }
        .percent-progress {
          background-color: #ccc !important;
          -webkit-print-color-adjust: exact;
        }
      }
    }
  }
  .result-text-two-print {
    .score {
      background-color: #fff !important;
      -webkit-print-color-adjust: exact;
    }
    .score-percent {
      .icon {
        background-color: #4c845d !important;
        -webkit-print-color-adjust: exact;
      }
      .percent {
        background: linear-gradient(to right, #c70000 50%, #4c845d 70%) !important;
        -webkit-print-color-adjust: exact;
        span {
          color: #fff !important;
          -webkit-print-color-adjust: exact;
        }
        .percent-progress {
          background-color: #ccc !important;
          -webkit-print-color-adjust: exact;
        }
      }
    }
  }

  .result-text-one-print,
  .result-text-two-print {
    // -webkit-transform: rotate(-90deg);
    // -moz-transform:rotate(-90deg);
    // filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
    height: 100%;
    .btn {
      display: none !important;
    }

    .score {
      // height: 30%;
      padding-top: 200px;
      h1 {
        color: #000 !important;
        -webkit-print-color-adjust: exact;
      }
    }
    .score-content {
      background-color: rgba(255, 255, 255, 0.85) !important;
      -webkit-print-color-adjust: exact;
    }
    .tabs {
      display: none !important;
    }
    .tpm-logo {
      bottom: 300px;
    }
  }
}
.btn-exit {
  position: absolute;
  z-index: 1;
  //background-color: #ff1800;
  right: 0;
  top: 15px;
  img {
    margin-right: 10px;
    width: 30px;
    cursor: pointer;
  }
/*bottom: 0;
  right: 0;
  color: #ffffff;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  font-family: 'comfortaabold';
  font-weight: bold;
  font-size: 18px;
  display: flex;
  align-items: center;
  &:hover {
    transform: none;
  }
  &:focus {
    box-shadow: 0 0 0 3px rgba($color: #ff1800, $alpha: 0.5);
  }*/
}
</style>
